import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone-uploader";
import Switch from "react-switch";
import { toast } from "react-toastify";
import { CardBody, Col, FormGroup, Label, ModalFooter, Row } from "reactstrap";
import { IMAGE_EXTENTION } from "../../../../Data/extentionImage";
import { DropZoneEventDto } from "../../../../models/dropZoneEventDto";
import { FileStatus } from "../../../../models/fileStatus";
import StepperActionButtons from "../../../stepper-action-button/stepperActionButton";
import styles from "./stepTwo.module.scss";
import { translate } from "react-switch-lang";

const StepTwo = (props: any) => {
  const [checked, setChecked] = useState<boolean>(false);
  const [titleSupport, setTitleSupport] = useState("");
  const [, setSelectedSupport] = useState<any>(null);
  const [, setSelectedSupportEdit] = useState<any>(null);
  const [isOnUpdate, setisOnUpdate] = useState(false);
  const [isShowDropZone, setIsShowDropZone] = useState(true);
  const [selectedSupportImage, setSelectedSupportImage] = useState<any>(null);
  const [urlImage, setUrlImage] = useState<string>("");
  useEffect(() => {
    if (props.support) {
      setisOnUpdate(true);
      setTitleSupport(props.support?.pathSupport?.slice(props.support?.pathSupport?.lastIndexOf("/") + 1, props.support?.pathSupport?.length));
      if (props.support.urlImage) {
        setIsShowDropZone(false);
      }
      setChecked(props.support.download);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeToggleDownload = () => {
    props.setChecked(!checked);
    setChecked(!checked);
  };

  const handleClickClearSelectedSupport = () => {
    setTitleSupport("");
    setSelectedSupport(null);
    setSelectedSupportEdit(null);
  };

  const handleChangeStatus = ({ meta, file }: DropZoneEventDto, status: string) => {
    if (isOnUpdate) {
      if (file) {
        if (file.type === "application/pdf") {
          setSelectedSupportEdit(file);
          setTitleSupport(file?.name);
          setTimeout(() => {}, 1000);
        } else {
          toast.error(String(props.t("message_extention_not_allowed")));
        }
      } else {
        setTitleSupport("");
        setSelectedSupportEdit(null);
      }
    } else {
      if (file) {
        if (file.type === "application/pdf") {
          setTitleSupport(file?.name);
          setSelectedSupport(file);
          props.setSelectedSupport(file);
          setTimeout(() => {}, 1000);
        } else {
          toast.error(String(props.t("message_extention_not_allowed")));
        }
      } else {
        setTitleSupport(file?.name);
      }
    }
  };

  const handleChangeStatusImage = ({ meta, file }: DropZoneEventDto, status: string) => {
    if (status === FileStatus.REMOVED) {
      setSelectedSupportImage(null);
      props.setSelectedSupportImage(null);
    } else {
      if (IMAGE_EXTENTION.includes(file.name.slice(file.name.lastIndexOf(".") + 1, file.name.length).toLowerCase())) {
        if (status === FileStatus.DONE) {
          setSelectedSupportImage(file);
          props.setSelectedSupportImage(file);
          setUrlImage(meta.previewUrl);
        }
      } else {
        toast.error(String(props.t("message_extention_not_allowed")));
      }
    }
  };

  return (
    <>
      <div className="card m-b-0 p-t-40">
        <CardBody className="p-t-5 p-b-5">
          <Col md="12">
            <FormGroup className="m-t-10">
              <div style={{ display: "flex" }}>
                <Col md="6">
                  <Label id="document">{props.t("pdf_modale.label_document")}*</Label>
                </Col>
                <Col md="6">
                  <Label style={{ float: "right" }} id="document">
                    <span style={{ paddingBottom: "5px", position: "relative", top: "-4px" }}>{props.t("pdf_modale.label_downloadable")}&emsp; </span>
                    <Switch height={20} width={40} onChange={handleChangeToggleDownload} checked={checked} />
                  </Label>
                </Col>
              </div>

              {titleSupport ? (
                <div className="text-center" style={{ width: "100%", height: "100px", background: "#efefefbf", border: "none !important" }}>
                  <div className="" style={{ position: "relative", top: "30px" }}>
                    {titleSupport}
                    <i onClick={handleClickClearSelectedSupport} className="fa fa-times  p-l-5"></i>
                  </div>
                </div>
              ) : (
                <Dropzone
                  key="in"
                  onChangeStatus={handleChangeStatus}
                  maxFiles={1}
                  accept={"application/pdf"}
                  multiple={false}
                  canCancel={false}
                  inputContent={
                    <div key="3">
                      <span style={{ fontSize: "25px", color: "black" }} className="bold">
                        <i className="fa fa-plus"></i> {props.t("pdf_modale.label_choose_document")}
                      </span>{" "}
                      <div style={{ fontSize: "14px", color: "gray" }}>{props.t("pdf_modale.label_drag_and_drop_here")}</div>
                    </div>
                  }
                  styles={{
                    dropzone: { height: 50, background: "#efefefbf", border: "none !important" },
                    dropzoneActive: { border: "none !important" },
                  }}
                />
              )}
            </FormGroup>
            <FormGroup className="col-md-12" style={{ width: "100%" }}>
              <Row>
                <Label id="upload">{props.t("pdf_modale.label_representative_image")}</Label>
                {isShowDropZone &&
                  (!selectedSupportImage ? (
                    <Dropzone
                      key="in"
                      onChangeStatus={handleChangeStatusImage}
                      maxFiles={1}
                      accept={"image/*"}
                      multiple={false}
                      canCancel={true}
                      inputContent={
                        <div key="2">
                          <span style={{ fontSize: "25px", color: "black" }} className="bold">
                            <i className="fa fa-plus"></i>
                            {props.t("pdf_modale.label_choose_image")}
                          </span>
                          <div style={{ fontSize: "14px", color: "gray" }}>{props.t("pdf_modale.label_drag_and_drop_here")}</div>
                        </div>
                      }
                      styles={{
                        dropzone: { width: "100%", height: 50, background: "#efefefbf", border: "none !important" },
                        dropzoneActive: { border: "none !important" },
                      }}
                    />
                  ) : (
                    <div className="text-center" style={{ width: "100%" }}>
                      <div className="uploadPictureP">
                        <div
                          onClick={() => {
                            setSelectedSupportImage(null);
                            props.setSelectedSupportImage(null);
                            props.setIsShowDropZone(true);
                          }}
                          className={styles["deleteImageVideo"]}
                        >
                          X
                        </div>
                        <img className={styles["defaultImage"]} src={urlImage} alt="" />
                      </div>
                    </div>
                  ))}

                {!isShowDropZone && (
                  <div className="text-center" style={{ width: "100%" }}>
                    <div className="uploadPictureP">
                      <div
                        onClick={() => {
                          setIsShowDropZone(!isShowDropZone);
                          setSelectedSupportImage(null);
                          props.setSelectedSupportImage(null);
                          props.setIsShowDropZone(true);
                        }}
                        className={styles["deleteImageVideo"]}
                      >
                        X
                      </div>
                      <img className={styles["defaultImage"]} src={props.support?.urlImage} alt="" />
                    </div>
                  </div>
                )}
              </Row>
            </FormGroup>
            <ModalFooter className="m-t-30 p-b-0 p-t-5">
              <StepperActionButtons disable={titleSupport === ""} lastStep={() => {}} {...props} nextStep={() => {}} />
            </ModalFooter>
          </Col>
        </CardBody>
      </div>
    </>
  );
};

export default translate(StepTwo);
